import { render } from "./ConsultaPontos.vue?vue&type=template&id=7a8ca132&scoped=true"
import script from "./ConsultaPontos.vue?vue&type=script&lang=js"
export * from "./ConsultaPontos.vue?vue&type=script&lang=js"

import "./ConsultaPontos.vue?vue&type=style&index=0&id=7a8ca132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8ca132"]])

export default __exports__